export const apiMethods = {
  post: "POST",
  get: "GET"
};
